import { Button } from '@mantine/core';
import { useTranslation } from '../context/TranslationContext';

export default function AddressList({ addresses, loading, onSetDefault, onDelete, type }) {
  const { t } = useTranslation();
  if (loading) return <p role="status" aria-live="polite">{t('loading', 'Loading…')}</p>;
  if (!addresses.length) return <p role="status">{type === 'shipping' ? t('noShippingAddresses', 'No shipping addresses yet.') : t('noBillingAddresses', 'No billing addresses yet.')}</p>;
  return (
    <div className="address-list" role="list" aria-label={type === 'shipping' ? t('shippingAddressesList', 'Saved shipping addresses') : t('billingAddressesList', 'Saved billing addresses')}>
      {addresses.map((addr) => {
        const summary = `${addr.full_name}${addr.company_name ? ', ' + addr.company_name : ''} — ${addr.address_line1}${addr.address_line2 ? ', ' + addr.address_line2 : ''}, ${addr.postal_code} ${addr.city}, ${addr.country}`;
        return (
        <article
          key={addr.id}
          className={`address-card ${addr.is_default ? 'default' : ''}`}
          role="listitem"
          aria-label={`${addr.is_default ? t('defaultAddress', 'Default') + ' ' : ''}${type === 'shipping' ? t('shippingAddress', 'Shipping address') : t('billingAddress', 'Billing address')} for ${addr.full_name}`}
        >
          <div className="address-card-name">
            <strong>{addr.full_name}</strong>
          </div>
          <div className="address-card-default">
            {!addr.is_default ? (
              <Button
                variant="outline"
                size="xs"
                className="set-default-btn"
                onClick={() => onSetDefault(addr)}
                aria-label={`${t('setAsDefault', 'Set as default')} — ${summary}`}
              >
                {t('setAsDefault', 'Set as Default')}
              </Button>
            ) : (
              <span className="default-badge" role="status">{t('defaultAddress', 'default')}</span>
            )}
          </div>
          <div className="address-card-details">
            {addr.company_name ? <div>{addr.company_name}</div> : null}
            {addr.vat_number ? <div>{t('vatNumber', 'VAT Number')}: {addr.vat_number}</div> : null}
            <div>{addr.address_line1}</div>
            {addr.address_line2 ? <div>{addr.address_line2}</div> : null}
            <div>{addr.postal_code} {addr.city}</div>
            <div>{addr.country}</div>
          </div>
          {onDelete ? (
            <div className="address-card-delete">
              <Button
                variant="light"
                color="red"
                size="xs"
                className="delete-btn"
                onClick={() => onDelete(addr.id)}
                aria-label={`${t('delete', 'Delete')} ${type === 'shipping' ? t('shippingAddress', 'Shipping address') : t('billingAddress', 'Billing address')} for ${addr.full_name}`}
              >
                {t('delete', 'Delete')}
              </Button>
            </div>
          ) : null}
        </article>
      );
      })}
    </div>
  );
}
